import { v4 as uuidv4 } from 'uuid';
export function generate() {
    return uuidv4();
}
export function iutkMiddleware(domain) {
    return (req, res, next) => {
        if (!req.cookies.iutk) {
            const iutk = generate();
            res.locals.iutk = iutk;
            req.cookies.iutk = iutk;
            res.cookie('iutk', iutk, {
                domain,
                httpOnly: false,
                maxAge: 60 * 60 * 24 * 30 * 6 * 1000,
                path: '/',
            });
        }
        else {
            res.locals.iutk = req.cookies.iutk;
        }
        next();
    };
}
